module.exports = __webpack_public_path__ + "334357b65708d32f5bdd91ade5f51c29.svg";